<template>
    <AppHead title="Feedback Submitted">
        <meta name="robots" content="noindex, follow"/>
    </AppHead>

    <from-website :website="website">
        <div class="text-center">
            <img class="mx-auto" src="/images/misc/check-circle.svg">
        </div>

        <app-title class="font-bold text-center my-6">Feedback Submitted</app-title>

        <p class="my-5 text-center">
            Thank you for taking time to leave feedback.
        </p>

        <p class="my-5 text-center">
            It has been passed on to our customer service team, someone will be in touch if there are any points that need actioning as part of your feedback.
        </p>

        <p class="my-5 text-center">
            Redirecting you to
            <a :href="website.url" @click="redirect" class="font-bold text-black">
                {{ website.domain }}
            </a> in {{ count }}...
        </p>
    </from-website>
</template>

<script>
import AppTitle from "@/Components/AppTitle.vue";
import FromWebsite from "@/Layouts/FromWebsite.vue";
import AppHead from "@/Components/AppSeoTags";

export default {
    layout: null,
    components: {
        AppTitle,
        AppHead,
        FromWebsite
    },
    props: {
        website: Object,
        config: Object
    },
    data() {
        return {
            count: 10
        };
    },
    watch: {
        count(value) {
            if (value > 0) this.startCount();

            if (value <= 0) {
                this.redirect();
            }
        }
    },
    mounted() {
        this.startCount();
    },
    methods: {
        startCount() {
            setTimeout(() => this.count--, 1000);
        },
        redirect() {
            if (this.config.env === "local") {
                alert("Redirect");
            } else {
                window.location.href = this.website.url;
            }
        },
    }
};
</script>


<style lang="scss" scoped>

</style>
